import { NAME } from './constants';

export const getModel = state => state[NAME];